import { Scope } from './interface'

export default function a8soloUI(scope: Scope) {
    return `
        declare var a8soloUI: {
            clearSessions();
            restart();
            openWidget();
            closeWidget();
            complete();
            goBack();
            save()
        };
    `
}
